import { Component } from 'preact';
import ListPaginationApp from './index';
import { mapFieldsV2 } from '../SearchFilterSidebarApp/UsedModelsFullStock';

export default class ListPaginationUsedModelsFullStockApp extends Component {
  render() {
    return (
      <ListPaginationApp
        mapFields={mapFieldsV2}
        methodAPI="getUsedModelsFullStock"
        category="Clone"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
      />
    );
  }
}
